module.exports = {
  zh: {
    // tag页title中文对应的配置，和router/index.js路由里的meta里的title对应。如果不加，新的页面，就不用配置当前对象
    route: {
      systemName: '在线教育管理后台',
      chainParkManagement: '连锁园管理',
      gardenManagement: '园所管理',
      gardenInfo: '园所信息',
      schoolCalendar: '校历',
      studentCalendar: "学生校历",
      staffCalendar: "职工校历",
      classSetting: '班级设置',
      staffManagement: '职工管理',
      staffIndexList: '职工管理',
      staffInfoDetails: '职工信息详情',
      staffAdd: '添加职工',
      studentManagement: '学生管理',
      studentManagementList: '学生管理列表',
      studentDetails: '学生详情',
      parentsManagement: '家长管理',
      parentsManagementList: '家长管理列表',
      parentsDetails: '家长详情',
      enrollAndRecruit: '报名招生',
      enrollFormManagement: '报名表管理',
      channelManagement: '报名渠道管理',
      enrollmentDataFunnel: '招生数据漏斗',
      divisionStatistics: '分班统计',
      interviewQuestions: '面试题目管理',
      admissionsManagement: '招生管理',
      enrollmentManagement: '招生管理',
      applicationRegistration: '预约参观',
      registrationDetails: '预约参观详情',
      interviewAppointment: '面谈',
      interviewAppointmentDetails: '面谈详情',
      gardenChecking: '考核入园',
      gardenCheckingDetails: '考核入园详情',
      notificationManagement: '通知管理',
      newNotification: '新建通知',
      offerSended: '已发送offer',
      offerSendedDetails: '已发送offer详情',
      confirmEnterGargen: '确认入园',
      confirmEnterGargenDetails: '确认入园详情',
      cancleEnterGargen: '取消入园',
      cancleEnterGargenDetails: '取消入园详情',
      notificationDetails: '通知详情',
      notificationListDisplay: '通知列表',
      studentLeaveList: '学生请假',
      studentLeaveNew: '新建请假',
      studentLeaveDetails: '请假详情',
      suggest: '意见反馈',
      chiefMailbox: '园长邮箱',
      dailyUpload: '日报上传',
      dailyDetails: '日报详情',
      siesta: '午睡',
      paymentManagement: '缴费管理',
      chargeSetting: '缴费项目设置',
      chargeRecord: '收费记录',
      headquartersCharges: '园所收费项目',
      studentPrivilegeManagement: '学生优惠管理',
      attendanceManagementIndex: '考勤管理',
      attendanceIndex: '考勤看板',
      attendanceConfiguration: '考勤配置',
      attendancesManagement: '考勤组管理',
      videoMonitoring: '视频监控',
      courseManagement: '课程管理',
      headquartersCourseManagement: '总部课程管理',
      gardenCourseManagement: '园所课程管理',
      classCourse: '班级课程',
      monthlyStaffstatisticst: '职工月度统计',
      studentMonthlystatisticst: '学生月度统计',
      staffDailyStatistics: '职工每日统计',
      studentDailyStatistics: '学生每日统计',
      originalCatalog: '原始记录',
      applicationManagement: '应用管理',
      deviceManagement: '设备管理',
      personalManagement: '人员管理',
      recipesDefine: '食谱定义',
      recipesNew: '新建食谱',
      recipesDetails: '食谱详情',
      menuDefine: '菜单定义index',
      newWeeklySetMeal: '新建周套餐',
      newDailyroutine: '新建日套餐',
      WeeklySetMealDetails: '周套餐详情',
      dailyroutineDetails: '日套餐详情',
      classMunuConfig: '班级菜单配置',
      classDailyMenu: '班级每日菜单',
      foodDistributionStatistics: '配餐统计',
      timetableScheduleList: '课表时间安排列表',
      timetableScheduleDetails: '课表时间详情',
      courseSeriesContent: '课程系列内容列表',
      courseSeriesContentNew: '课程系列内容新建',
      courseSeriesContentDetails: '课程系列内容详情',
      classCoursePlanList: '班级课程计划列表',
      classCoursePlanNew: '班级课程计划新建',
      classCoursePlanDetails: '班级课程计划详情',
      courseCalendarCheck: '课程日历查看',
      teachingCase: '教案列表',
      teachingCaseNew: '教案新建',
      teachingCaseDetails: '教案详情',
      authorityManagementIndex: '权限管理',
      user: '用户',
      role: '角色',
      systemSet: '系统设置',
      information: '基本信息',
      dictionaries: '字典设置',
      Journal: '日志管理',
      passwordChange: '密码修改',
    },
  },
  en: {
    route: {
      systemName: 'online education admin management',
      chainParkManagement: 'ChainParkManagement',
      gardenManagement: 'gardenManagement',
      gardenInfo: 'gardenInfo',
      schoolCalendar: 'schoolCalendar',
      studentCalendar: "Public Version",
      staffCalendar: "School Version",
      classSetting: 'classSetting',
      staffManagement: 'staffManagement',
      staffIndexList: 'staffIndexList',
      staffInfoDetails: 'staffInfoDetails',
      staffAdd: 'staffAdd',
      studentManagement: 'studentManagement',
      studentManagementList: 'studentManagementList',
      studentDetails: 'studentDetails',
      parentsManagement: 'parentsManagement',
      parentsManagementList: 'parentsManagementList',
      parentsDetails: 'parentsDetails',
      enrollAndRecruit: 'enrollAndRecruit',
      enrollFormManagement: 'enrollFormManagement',
      channelManagement: 'Registration Channel Management',
      enrollmentDataFunnel: 'Enrollment Data Funnel',
      divisionStatistics: 'divisionStatistics',
      interviewQuestions: 'InterviewQuestionsManagement',
      admissionsManagement: 'admissionsManagement',
      enrollmentManagement: 'Enrollment management',
      applicationRegistration: 'applicationRegistration',
      registrationDetails: 'registrationDetails',
      interviewAppointment: 'interviewAppointment',
      interviewAppointmentDetails: 'interviewAppointmentDetails',
      gardenChecking: 'gardenChecking',
      gardenCheckingDetails: 'gardenCheckingDetails',
      notificationManagement: 'notificationManagement',
      newNotification: 'newNotification',
      offerSended: 'offerSended',
      offerSendedDetails: 'offerSendedDetails',
      confirmEnterGargen: 'confirmEnterGargen',
      confirmEnterGargenDetails: 'confirmEnterGargenDetails',
      cancleEnterGargen: 'cancleEnterGargen',
      cancleEnterGargenDetails: 'cancleEnterGargenDetails',
      //   divisionStatistics: 'divisionStatistics',
      notificationListDisplay: 'NotificationListDisplay',
      notificationDetails: 'NotificationDetails',
      studentLeaveList: 'studentLeaveList',
      studentLeaveNew: 'studentLeaveNew',
      studentLeaveDetails: 'studentLeaveDetails',
      suggest: 'suggest',
      chiefMailbox: 'chiefMailbox',
      dailyUpload: 'dailyUpload',
      dailyDetails: 'dailyDetails',
      siesta: 'siesta',
      paymentManagement: 'paymentManagement',
      chargeSetting: 'chargeSetting',
      chargeRecord: 'chargeRecord',
      headquartersCharges: 'Headquarters charges',
      studentPrivilegeManagement: 'Student privilege management',
      attendanceManagementIndex: 'attendanceManagementIndex',
      attendanceIndex: 'attendanceIndex',
      attendanceConfiguration: 'attendanceConfiguration',
      attendancesManagement: 'attendancesManagement',
      videoMonitoring: 'videoMonitoring',
      courseManagement: 'Curriculum',
      headquartersCourseManagement: 'Headquarter',
      gardenCourseManagement: 'School',
      classCourse: 'Teacher',
      monthlyStaffstatisticst: 'monthlyStaffstatisticst',
      studentMonthlystatisticst: 'studentMonthlystatisticst',
      staffDailyStatistics: 'staffDailyStatistics',
      studentDailyStatistics: 'studentDailyStatistics',
      originalCatalog: 'originalCatalog',
      personalManagement: 'personalManagement',
      recipesDefine: 'recipesDefine',
      recipesNew: 'recipesNew',
      recipesDetails: 'recipesDetails',
      menuDefine: 'menuDefine',
      newWeeklySetMeal: 'newWeeklySetMeal',
      newDailyroutine: 'newDailyroutine',
      WeeklySetMealDetails: 'WeeklySetMealDetails',
      dailyroutineDetails: 'dailyroutineDetails',
      classMunuConfig: 'classMunuConfig',
      classDailyMenu: 'classDailyMenu',
      foodDistributionStatistics: 'foodDistributionStatistics',
      timetableScheduleList: 'timetableScheduleList',
      timetableScheduleDetails: 'timetableScheduleDetails',
      courseSeriesContent: 'courseSeriesContent',
      courseSeriesContentNew: 'courseSeriesContentNew',
      courseSeriesContentDetails: 'courseSeriesContentDetails',
      classCoursePlanList: 'classCoursePlanList',
      classCoursePlanNew: 'classCoursePlanNew',
      classCoursePlanDetails: 'classCoursePlanDetails',
      courseCalendarCheck: 'courseCalendarCheck',
      teachingCase: 'teachingCase',
      teachingCaseNew: 'teachingCaseNew',
      teachingCaseDetails: 'teachingCaseDetails',
      authorityManagementIndex: 'authorityManagementIndex',
      user: 'user',
      role: 'role',
      systemSet: 'systemSet',
      information: 'information',
      dictionaries: 'dictionaries',
      Journal: 'Log Query',
      passwordChange: 'Password Change',
    },
  }

}



// WEBPACK FOOTER //
// ./src/components/i18n/lang/route.js